import moment from "moment"
import {
  closeWeeklyTaskNotification,
  getRecommendedTasks,
  setTaskCompletion,
} from "../../api/task"

const state = {
  recommendedTasks: [],
  gameId: "",
  isNotificationClosed: false,
  taskListId: 0,
  taskError: false,
  loading: true,
}

const getters = {
  recommendedTasks: state => state.recommendedTasks,
  isNotificationClosed: state => state.isNotificationClosed,
  taskListId: state => state.taskListId,
  taskError: state => state.taskError,
  loading: state => state.loading,
}

const mutations = {
  setRecommendedTasks: (state, tasks) => (state.recommendedTasks = tasks),
  setGameId: (state, id) => (state.gameId = id),
  setIsNotificationClosed: (state, bol) => (state.isNotificationClosed = bol),
  setTaskListId: (state, id) => (state.taskListId = id),
  setTaskError: (state, error) => (state.taskError = error),
  setLoading: (state, loading) => (state.loading = loading),
}

const actions = {
  async loadRecommendedTasks ({ commit }, { gameId, update }) {
    commit("setLoading", true)
    const time = moment().unix()
    const data = await getRecommendedTasks(gameId, time, update)
    commit("setGameId", gameId)
    commit("setRecommendedTasks", data.tasks)
    commit("setIsNotificationClosed", data.is_notification_closed)
    commit("setTaskListId", data.id)
    commit("setLoading", false)
  },
  async setTaskCompletion ({ state, commit }, { taskId, completed }) {
    const body = {
      is_completed: completed,
    }
    await setTaskCompletion(taskId, body)
    const tasks = state.recommendedTasks
    for (let task of tasks) {
      if (task.id === taskId) {
        task.completed_at = completed
        break
      }
    }
    commit("setRecommendedTasks", tasks)
    // dispatch("loadRecommendedTasks", { gameId: state.gameId })
  },
  async closeWeeklyTaskNotification ({ commit, state }) {
    await closeWeeklyTaskNotification(state.taskListId)
    commit("setIsNotificationClosed", true)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/task.js